import { render, staticRenderFns } from "./TopicContentItem.vue?vue&type=template&id=47fd0de4&"
import script from "./TopicContentItem.vue?vue&type=script&lang=js&"
export * from "./TopicContentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports